import filterObjectProperties from '../objects/filterObjectProperties';
import mapObject from '../objects/mapObject';

import objectToQueryString from './objectToQueryString';
import queryStringToObject from './queryStringToObject';

const compileUrl = (
    url: string,
    params: Record<string, string | number | boolean | undefined>
) => {
    const [baseUrl, queryString] = url.split('?');
    const mergedParams = {
        ...queryStringToObject(queryString ?? ''),
        ...params,
    };

    /** Remove keys that have been explicitly set to undefined */
    const filteredParams = filterObjectProperties(
        mergedParams,
        (key, value) => value !== undefined && value !== null
    );

    /** Convert all values to strings */
    const paramsAsStrings = mapObject(filteredParams, (value) => {
        if (typeof value === 'boolean') {
            return value ? '1' : '0';
        }

        return value?.toString();
    }) as Record<string, string>;

    return `${baseUrl}?${objectToQueryString(paramsAsStrings)}`;
};

export default compileUrl;
